import { createClient } from '@supabase/supabase-js';

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY
} = process.env

const supabaseUrl: string = REACT_APP_SUPABASE_URL;
const supabaseAnonKey: string = REACT_APP_SUPABASE_ANON_KEY;

export const supabaseClient = createClient(supabaseUrl, supabaseAnonKey);